import './auto-width-slider.component.scss';
import {} from 'jquery';
import { TinySliderInstance, tns } from 'tiny-slider';
import GLightbox from 'glightbox';


export class AutoWidthSliderComponent {
	static MAIN_CLASS = 'auto-width-slider';
	
	/*
	 * STATIC STUFF
	 */

	static compileAll() {
		jQuery('.' + AutoWidthSliderComponent.MAIN_CLASS).each((_, el) => {
			new AutoWidthSliderComponent(jQuery(el));
		});
	}

	/**
	 * INSTANCE STUFF
	 */

	private slider!: TinySliderInstance;
	private lightbox!: ReturnType<typeof GLightbox>;

	constructor(private readonly jqElement: JQuery) {
		this.initSlider();
		this.registerLightbox();
	}

	private initSlider() {
		const container = this.jqElement.find('.auto-width-slider-inner')[0];
		this.slider = tns({
			container,
			items: 3.3,
			gutter: 10,
			speed: 400,
			autoWidth: true,
			loop: false,
			rewind: true,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			touch: true,
			nav: true,
			controls: false,
		});
	}

	private registerLightbox() {

		const id = this.jqElement.attr('id');

		this.lightbox = GLightbox({
			selector: `#${id} a.lightbox-trigger`,
			loop: true,
			autoplayVideos: true,
			touchNavigation: true,
			keyboardNavigation: true,
		});
	}
}
